import { render, staticRenderFns } from "./ProfileTeamsPage.vue?vue&type=template&id=40eee14e&scoped=true&"
import script from "./ProfileTeamsPage.vue?vue&type=script&lang=js&"
export * from "./ProfileTeamsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTeamsPage.vue?vue&type=style&index=0&id=40eee14e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eee14e",
  null
  
)

export default component.exports